import { isComment, isEntity, isEntityLink, isLink, isProfile, isTypedElement } from '@tunasong/schemas'
import type { CoreElement, ElementType } from '@tunasong/schemas'
import { isTopLevelEntity } from '../element/entity.js'

export type FilterFunc<T = unknown> = (node?: T) => boolean

export const isSameEntity = (id?: string) => (node?: unknown) => Boolean(id && isEntity(node) && id === node.id)
export const negateFilter = (filter: FilterFunc) => (node?: unknown) => !filter(node)

export const matchAny =
  (...funcs: FilterFunc[]) =>
  (el?: unknown) =>
    Boolean(funcs.find(func => func(el)))

export const matchTypes =
  (types: ElementType[] | boolean = []) =>
  (el?: unknown) =>
    Boolean(isTypedElement(el) && Array.isArray(types) ? types.includes(el.type) : types)

export const matchAll =
  (...funcs: FilterFunc[]) =>
  (el?: unknown) =>
    Boolean(funcs.every(func => func(el)))

export const matchNone = (...funcs: FilterFunc[]) => negateFilter(matchAny(...funcs))

export const includeElement = (element?: unknown, filter?: FilterFunc | ElementType) =>
  typeof filter === 'function' ? filter(element) : filter ? filter === (element as CoreElement)?.type : true

export const EntityFilters = {
  /*
   * What a folder's content views show. Grid and List previously used different
   * filters — Grid hid only profiles, List hid notes/comments/links but showed
   * profiles — so the same folder listed different children per view. Notes are
   * deliberately visible: Inbox rules file captured notes into folders, and a
   * filed note the folder view hides is effectively lost. Comments and links are
   * annotations on other entities, not content; the per-folder type filter is
   * the place for users to hide further types.
   */
  folder: matchNone(isProfile, isComment, isLink, isEntityLink),
  defaultSearch: isTopLevelEntity,
}
